<template>
<div class="sections">
    <component
        v-for="section, i in site_data.sections"
        :key="'section-' + i"
        :is="section.component"
        :section_data="section"
        :is_mobile="is_mobile"
        :data-anchor="section.anchor"
    />
</div>
</template>

<script>
import * as components from './index.js';
import * as sections from '../blocks/sections/index.js';
export default {
    name        :   'HomePage',
    props       :   ['site_data', 'is_mobile'],
    components  :   { components, ...sections }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue